import { Grid, GridProps } from "@mui/material";
import React from "react";

interface MxFormLayoutProps extends GridProps {
  children: React.ReactNode;
}
const MxDetailLayoutMain = (props: MxFormLayoutProps) => {
  return (
    <Grid container py={2} px={1.5}>
      <Grid {...props} item xs={12} borderRadius={2} pb={2}>
        {props.children}
      </Grid>
    </Grid>
  );
};

export default MxDetailLayoutMain;
